/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "./src/styles/global.css";

import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { LanguagesProvider } from "./src/contexts/languagesContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <LanguagesProvider>{element}</LanguagesProvider>
);